import { bindable, inject } from 'aurelia-framework';
import { State } from '../../services/global-state';
import { PayrazrService } from '../../services/payrazr';

@inject(Element, PayrazrService, State)
export class BannerImageCustomElement {
	@bindable textOnly: any;
	element: Element;
	payrazr: PayrazrService;
	globalState: State;
	bannerText: string;
	src: string;
	useImage: any;

	constructor(element: Element, payrazr: PayrazrService, globalState: State) {
		this.element = element;
		this.payrazr = payrazr;
		this.globalState = globalState;

		this.bannerText = globalState.business.portalSettings.title || globalState.business.portalSettings.name;
		this.src = globalState.business.portalSettings.bannerImageUrl;
	}

	attached() {
		this.useImage = !this.textOnly && this.globalState.business.portalSettings.hasBanner;
	}
}
